import React from 'react';

export interface IAccountLoginSubHeaderProps {
  email?: string;
  hasSubmittedEmail: boolean;
  onValidEmailReset: (e: any) => void;
  subHeaderText?: string;
}

const AccountLoginSubHeader: React.SFC<IAccountLoginSubHeaderProps> = (
  props: IAccountLoginSubHeaderProps,
) => {
  const { subHeaderText, email, onValidEmailReset, hasSubmittedEmail } = props;

  if (hasSubmittedEmail) {
    return (
      <div className="small-margin-top large-margin-bottom text-center">
        Signing in as{' '}
        <button className="text-blue text-button" onClick={onValidEmailReset}>
          {email}
          <svg width="11px" height="8px" viewBox="0 0 11 8">
            <polygon
              className="dropdown"
              transform="translate(5.545942, 1.818915) rotate(-45.000000) translate(-5.545942, -1.818915)"
              points="3.5720013 3.79285577 3.5720013 -1.90963845 1.81738608 -1.90963845 1.81738608 4.67016238 1.81738608 5.54746899 9.27449702 5.54746899 9.27449702 3.79285577"
            />
          </svg>
        </button>
      </div>
    );
  } else if (subHeaderText) {
    return <div className="small-margin-top large-margin-bottom text-center">{subHeaderText}</div>;
  }
  return null;
};

export default AccountLoginSubHeader;
